/** @format */
import mochi_cheer from "../../../assets/images/mochi_cheer.png";
import style from "./index.module.scss";

const MochiImage_modal = () => {
    return <div className={style['mochi_cheer_component']}>
		<img width={231} src={mochi_cheer} alt='' />;
	</div>
};
export default MochiImage_modal;
